'use client';

import * as React from 'react';
import { useParams } from 'next/navigation';
import { classnames } from 'helpers/utils/classnames';
import { GridProps } from './types';

const Grid = ({ children, wrapperClassName, gridClassName }: GridProps) => {
  const params = useParams();
  const slugArray = params?.slug as string[] | undefined;

  const isProwhip = slugArray?.includes('prowhip-home');

  return (
    <div className={isProwhip ? '' : wrapperClassName}>
      <div
        className={
          isProwhip
            ? 'grid grid-cols-12'
            : classnames('grid', 'grid-cols-12', gridClassName)
        }
      >
        {children}
      </div>
    </div>
  );
};

export default Grid;
